import BasicModal from '__components/Modals/presets/BasicModal';
import { TFunction, useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';
import { MarketplacePlugin } from 'pages/Marketplace/types';

interface WarningModalProps {
  onConfirm: (...args: any[]) => any;
  onHide: (...args: any[]) => any;
  show: boolean;
  plugin: MarketplacePlugin;
}

const entityByPluginName: Record<string, (t: TFunction) => string> = {
  intercom: (t) => t('support chat'),
  userpilot: (t) => t('onboarding'),
};

export const WarningModal = ({
  onConfirm,
  onHide,
  show = false,
  plugin,
}: WarningModalProps) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <BasicModal
      heading={t('Override {{pluginName}} Configuration', {
        pluginName: plugin.name,
      })}
      buttonText={t('Continue')}
      actionBtnColor="green"
      onConfirm={onConfirm}
      onHide={onHide}
      show
    >
      <div className="pb-2">
        <Typography>
          {t(
            "Enabling this plugin will disable Kizen's {{entity}}, and allow you to install your own. Would you like to continue?",
            {
              entity:
                entityByPluginName[plugin.api_name]?.(t) ?? t('installation'),
            }
          )}
        </Typography>
      </div>
    </BasicModal>
  );
};
